import { faChartLine, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IAddHandlerParams } from 'components/AddForm';
import { Audible } from 'components/Audible';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AddForm } from '../';
import { styled } from '../../assets/theme';
import { addItem, deleteItem, IUpdateItemParam, updateItem } from '../../redux/layout/actions';
// import { setToken } from '../../redux/auth/actions';
import ConnectionBadge from '../ConnectionBadge';
import { ThemeControl } from '../ThemeControl/themeControl';
import { SocketConnected } from '../../redux/socket/actions';
import EventsPanel from "../EventsPanel";
import htplogo_v3 from "assets/img/htplogo_v3.svg";
interface INavbarProps {
  keycloak: any
}

interface IConnectedProps {
  addWidgetItem: (options: IAddHandlerParams) => void
  socketConnect: (status: boolean) => void,
}

const Navbar: React.FunctionComponent<INavbarProps & IConnectedProps> = ({ keycloak, addWidgetItem, socketConnect }) => {
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => { setShowModal(false); };
  const handleOpenModal = () => { setShowModal(true); };
  const handleAddWidget = (options: IAddHandlerParams) => { addWidgetItem(options); };

	const logout = () => {
    socketConnect(false);
    keycloak.logout();
	};

	return (
    <div style={{ position: 'relative' }}>
      <NavbarContainer>
        <LogoWrapper>
          <a href="/">
            <object style={{ margin: "0px 0px -12px 0px"}} aria-label="htp logo" data={htplogo_v3} />
          </a>
        </LogoWrapper>
        <AddForm showModal={showModal} closeHandler={handleCloseModal} addHandler={handleAddWidget} />
        <ConnectionBadge />
        <div style={{ cursor: 'pointer' }} onClick={handleOpenModal}>
          <FontAwesomeIcon size="1x" icon={faChartLine} title="Add widgets" />
        </div>
        <div style={{ cursor: 'pointer' }} onClick={logout}>
        < FontAwesomeIcon size="1x" icon={faSignOutAlt} title="Log out" />
        </div>
        <Audible />
        <ThemeControl />
      </NavbarContainer>
      <EventsPanel id={100} />
    </div>
	);
};

const LogoWrapper = styled.div`
  g {
    fill: ${({ theme }) => theme.core.textColor};
  }
`;


const NavbarContainer = styled.div`
	display: grid;
  grid-template-columns: 1fr auto auto auto auto auto auto;
  grid-gap: 1em;
  border-bottom: solid 1px ${({ theme }) => theme.core.offBackground};
  color: ${({ theme }) => theme.core.textColor};
  padding: 10px;
  align-items: center;
`;

const mapDispatchToProps = (dispatch: Dispatch) => ({
  addWidgetItem: (options: IAddHandlerParams) => dispatch(addItem({ options })),
  deleteItem: (id: number) => dispatch(deleteItem({ id })),
  updateItem: (options: IUpdateItemParam[]) => dispatch(updateItem(options)),
  socketConnect: (status: boolean) => dispatch(SocketConnected(status))
});


export default connect<{}, IConnectedProps, {keycloak: any}>(null, mapDispatchToProps)(Navbar);
